export const apiCallParameters = {
    TECHNICIAN_ASSIGNMENT_TRAIL_DATA: "TechnicianAssignmentTrailData",
    TECHNICIAN_ASSIGNMENT_TRAIL_LAMBDA: "TechnicianAssignmentTrailLambda",
    GET_TRAIL_DATA: "getTrailData",
    PAGE_SIZE: 30
}

export const TECHNICIAN_ASSIGNMENT_TRAIL_TOOL = "TechnicianAssignmentTrailAuthZ";